import React, { useMemo } from "react";
import EventDetailsDefinitionList from "components/events/events/EventDetailsDefinitionList";
import columnRenderers from "security-app/components/SecurityEvents/Alerts/ColumnRenderers";
import TagsDetailRow from "components/events/TagsDetailRow";
const SecurityEventDetailsTable = ({ event, attributesList, interactiveTags = true }) => {
  const { attributes: attributesRenderers } = columnRenderers;
  const eventEntity = useMemo(() => {
    const { event: generalEvent, ...rest } = event;
    return { ...rest, ...generalEvent };
  }, [event]);
  const nonTagAttributesList = useMemo(() => attributesList.filter(({ id }) => id !== "tags"), [attributesList]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    EventDetailsDefinitionList,
    {
      event: eventEntity,
      attributesRenderers,
      attributesList: nonTagAttributesList
    }
  ), /* @__PURE__ */ React.createElement(TagsDetailRow, { tags: eventEntity.tags, interactive: interactiveTags }));
};
export default SecurityEventDetailsTable;
